module.exports = __webpack_public_path__ + "fonts/Hurricane-Regular.bc97d74.ttf";